module.exports = __webpack_public_path__ + "img/cp47-r3.2bcec218.jpg";